import { useCallback, useEffect, useRef } from 'react';
import useCustomHook from '@/hooks/useCustomHook';
import { ResizeObserver } from '@juggle/resize-observer';

export default function useGameStageContext({ scaleAxis, stageRef }) {
  const dimensions = useRef({ pxWidht: 0, pxHeight: 0 });

  const { state, actions } = useCustomHook({
    defaultState: {
      width: 0, // Will be calculated in pixels allways
      height: 0,
      responsiveLength: 0,
      scaleAxis: null,
      orientation: 'landscape',
    },
    actions: {},
  });

  const updateStageDimensions = useCallback(
    (entries) => {
      const stageRect = entries
        ? entries[0].contentRect
        : stageRef.current.getBoundingClientRect();

      const orientation =
        stageRect.width > stageRect.height ? 'landscape' : 'portrait';
      const axis =
        typeof scaleAxis == 'string' ? scaleAxis : scaleAxis[orientation];
      actions.setState({
        width: stageRect.width,
        height: stageRect.height,
        orientation,
        responsiveLength: {
          x: stageRect.width,
          y: stageRect.height,
        }[axis],
        scaleAxis: axis,
      });
    },
    [stageRef.current, scaleAxis]
  );

  useEffect(() => {
    if (typeof scaleAxis == 'string') {
      actions.setState({ scaleAxis });
    } else {
      const stageRect = stageRef.current.getBoundingClientRect();
      const orientation =
        stageRect.width > stageRect.height ? 'landscape' : 'portrait';
      actions.setState({ scaleAxis: scaleAxis[orientation] });
    }
  }, [scaleAxis]);

  useEffect(() => {
    //console.log('Setting Stage observer');
    let observer;
    if (stageRef.current != null) {
      updateStageDimensions();
      observer = new ResizeObserver(updateStageDimensions);
      observer.observe(stageRef.current);
    }
    return () => {
      if (observer) observer.disconnect();
    };
  }, [updateStageDimensions]);

  return { state, actions };
}
